<div class="row sp-around flex-column align-items-center align-items-xl-stretch content-product-landing" [ngClass]="detail.reverse ? 'flex-lg-row-reverse':'flex-lg-row'">
  <div class="col-lg-6 d-flex">
    <div class="me-3 d-none d-sm-inline">
      <img [src]="detail?.bullet" alt="">
    </div>
    <div class="d-flex flex-column sp-between">
      <div class="pb-4">
        <div class="d-flex al-center">
          <span class="fs-1 text-blue fw-bold">{{detail?.title}}</span>
        </div>
        <div class="my-3">
          <span class="fw-regular fs-5">{{detail?.description}}</span>
        </div>
        <div class="mb-2">
          <span class="text-sky fs-5 fw-bold">{{detail?.subtitle}}</span>
        </div>
        <div *ngFor="let f of detail?.functions">
          <div class="d-flex al-center mb-1">
            <img src="assets/svg/bullet.svg" class="me-3" alt="">
            <span class="fw-regular fs-5">{{f}}</span>
          </div>
        </div>
        <br><div class="d-none d-md-inline"><br><br></div>
        <div class="button-action bg-blue al-center d-flex sp-center fw-medium pointer" (click)="goTo(detail)">
          <span class="text-white fs-4">{{detail?.action}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-inline d-lg-none">
    <br><br>
  </div>
  <div class="col-lg-6 text-center">
    <img [src]="detail?.image" class="w-100 image-product" alt="">
  </div>
</div>
<div class="d-none d-md-inline"><br><br><br><br><br></div>